import { Avatar, Grid, Typography } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import React, { useEffect, useState } from 'react'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import { LoggedUser } from '../../../modules/auth/models/LoggedUser'
import { AUTH_SERVICE_KEY } from '../../../modules/auth'
import { getAuthContainer } from '../../../container/auth-modules'
import { URL_PROFILE_USER } from '../../../routes/routes-constants'
import { useNavigate } from 'react-router-dom'
import { AuthService } from '../../../modules/auth/services/AuthService'
import { getClientContainer } from '../../../container/client-modules'
import { ClientService } from '../../../modules/clients/services/ClientService'
import { CLIENTS_SERVICE_KEY } from '../../../modules/clients'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      color: theme.palette.grey['700'],
      fontWeight: 700,
    },
    subtitle: {
      color: theme.palette.grey['600'],
      fontWeight: 400,
      fontSize: '0.7rem',
    },
    exitIcon: {
      color: theme.palette.grey['700'],
    },
    avatar: {
      cursor: 'pointer',
    },
  })
)

const authService = getAuthContainer().get<AuthService>(AUTH_SERVICE_KEY)
const clientService = getClientContainer().get<ClientService>(CLIENTS_SERVICE_KEY)

export const Profile = () => {
  const classes = useStyles()
  const navigate = useNavigate()

  const [user, setUser] = useState<LoggedUser>(authService.get())
  const [taxIdentity, setTaxIdentity] = useState<string>('')

  const handleGoProfile = () => navigate(URL_PROFILE_USER)

  useEffect(() => {
    authService.getObservable().subscribe((u) => {
      setUser(u)
    })
  }, [])

  useEffect(() => {
    if (user.clinicID) {
      clientService.getByID(user.clinicID).subscribe((client) => {
        if (client) setTaxIdentity(client.taxIdentity)
      })
    }
  }, [user.clinicID])

  const logout = () => authService.logout2()

  return (
    <Grid container spacing={2} className={classes.avatar}>
      <Grid xs zeroMinWidth onClick={handleGoProfile}>
        <Typography align="right" className={classes.title}>
          {user.firstName} {user.lastName}
        </Typography>
        <Typography align="right" className={classes.subtitle}>
          {taxIdentity}
        </Typography>
      </Grid>
      <Grid>
        <Avatar>
          <ExitToAppIcon className={classes.exitIcon} onClick={logout} />
        </Avatar>
      </Grid>
    </Grid>
  )
}
